<template>
  <el-form
    :model="accountForm"
    status-icon
    :rules="rules"
    ref="basicInformationForm"
  >
    <el-row class="layout__padding-0-50px el-row--flex justify-center">
      <el-col :span="5">
        <div
          v-for="(field, fieldName) in fields"
          v-if="! field.isHidden"
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
          :key="fieldName"
        >
          {{ field.placeholder }}
        </div>
      </el-col>

      <el-col
        :span="7"
        class="layout__padding__right-20px"
      >
        <el-form-item
          v-for="(field, fieldName) in fields"
          :prop="fieldName"
          :hidden="field.isHidden"
          :key="fieldName"
        >
          <el-input
            class="layout__max-width-250px"
            :placeholder="field.placeholder"
            v-model="accountForm[fieldName]"
            :readonly="field.isDisabled"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row
      class="layout__padding-0-50px text__align-center"
    >
      <div class="layout__padding-20-0">
        <div class="layout__display-inline-block">
          <el-form-item>
            <el-checkbox
              class="layout__border__bottom-none text__direction-left-to-right"
              v-model="accountForm.marketingEmailsConsent"
            >
              <div class="layout__padding__left-20px font-12-required">
                Keep me informed of exclusive news and offers
              </div>
            </el-checkbox>
          </el-form-item>
        </div>
      </div>
    </el-row>

    <div
      v-if="showRecaptcha"
      class="d-flex justify-center mb-20"
    >
      <vue-recaptcha
        ref="recaptcha"
        :key="recaptchaKey"
        @verify="onVerify"
        @expired="onExpired"
        :sitekey="recaptchaSiteKey"
      />
    </div>

    <div class="d-flex justify-center">
      <el-button
        class="button-tickled-pink button__base layout__width-150px layout__margin__right-10px"
        @click="back"
      >
        Back
      </el-button>

      <el-button
        class="button__background-tickled-pink layout__width-150px"
        :disabled="! recaptchaChecked"
        @click="register"
      >
        Next
      </el-button>
    </div>
  </el-form>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'CustomerDetails',

  components: {
    VueRecaptcha,
  },

  props: {
    accountType: {
      type: String,
      required: true,
    },

    paymentMethod: {
      type: String,
      required: true,
    },

    isLoading: {
      type: Boolean,
      required: true,
    },

    finalForm: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      fields: {
        accountType: {
          placeholder: 'Account Type',
          isHidden: true,
          isDisabled: true,
        },
        paymentMethod: {
          placeholder: 'Payment',
          isHidden: true,
          isDisabled: true,
        },
        paymentMethodReadable: {
          placeholder: 'Payment',
          isHidden: true,
          isDisabled: true,
        },
        firstName: {
          placeholder: 'First name',
          isHidden: false,
          isDisabled: false,
        },
        surname: {
          placeholder: 'Surname',
          isHidden: false,
          isDisabled: false,
        },
        telephone: {
          placeholder: 'Telephone',
          isHidden: false,
          isDisabled: false,
        },
        email: {
          placeholder: 'Email address',
          isHidden: false,
          isDisabled: false,
        },
      },
      accountForm: {
        firstName: '',
        surname: '',
        telephone: '',
        email: '',
        accountType: this.accountType,
        paymentMethod: this.paymentMethod,
        paymentMethodReadable: '',
        marketingEmailsConsent: false,
      },
      rules: {
        firstName: [
          { required: true, message: 'First name required', trigger: 'blur' }
        ],
        surname: [
          { required: true, message: 'Surname required', trigger: 'blur' }
        ],
        telephone: [
          { required: true, message: 'Telephone required', trigger: 'blur' },
          {
            required: true,
            pattern: /^[0-9, ]*$/,
            message: 'Telephone invalid',
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: 'Email required', trigger: 'blur' },
          {
            required: true,
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'Main Contact Email invalid',
            trigger: 'blur'
          }
        ],
      },
      recaptchaKey: 0,
      showRecaptcha: true,
      recaptchaChecked: false,
      recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    };
  },

  computed: {
    paymentMethodReadable() {
      return this.paymentMethod === 'PAYGEMAILINVOICE' ? 'PAYG email invoice' : 'Monthly email invoice';
    }
  },

  mounted() {
    this.accountForm.paymentMethodReadable = this.paymentMethodReadable;

    if (`${process.env.VUE_APP_ENVIRONMENT}` === 'dev' || `${process.env.VUE_APP_ENVIRONMENT}` === 'qa') {
      this.showRecaptcha = false;
      this.recaptchaChecked = true;
    }
  },

  methods: {
    onVerify() {
      this.recaptchaChecked = true;
    },

    onExpired() {
      this.recaptchaKey += 1;
    },

    register() {
      this.$refs.basicInformationForm.validate((valid) => {
        if (! valid || this.isLoading) {
          return;
        }

        const userData = { ...this.accountForm };

        delete userData['paymentMethodReadable'];

        this.$emit('step-passed', {
          userData,
          saveUser: true,
          finishRegistration: false,
          nextStep: 'company-details',
        });
      });
    },

    back() {
      this.$emit('back-button-pressed');
    },
  },
};
</script>